import { Multicountry } from '../../../../../../shared/interfaces/create-surveys.interface';
import { SortCountry } from '../interface/sort-country';
import { Alphabethical } from './alphabethical';
import { CanadaFirst } from './canada-first';
import { UnitedStatesFirst } from './united-state-first';

export class UnitedStatesCanadaAlphabeticalSort implements SortCountry {
  constructor(public readonly countryList: Multicountry[]) {}

  sort(): Multicountry[] {
    let result = [];
    result = new Alphabethical(this.countryList).sort();
    result = new CanadaFirst(result).sort();
    result = new UnitedStatesFirst(result).sort();
    return result;
  }
}
